import { useMemo } from 'react';
import { isLiveStream } from '@core/livestream/helpers';
import { formatLiveStreamSubtitles, formatVideoSubtitles, } from '@embed/components/VideoPlayer/Player3/features/TextCues/VTT/helpers';
import { useVideoEl } from '@embed/components/VideoPlayer/Player3/hooks/useVideoEl';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { useVideoPlayerStore } from '@embed/components/VideoPlayer/store';
import { videoPlayerIsMinimizedSelector } from '@embed/components/VideoPlayer/store/selectors';
/**
 * Determine if subtitles are enabled and if the given video has subtitles
 * @returns {
 *  areAvailable - if the current video has subtitles
 *  areEnabled - if subtitles are currently enabled
 *  currentSubtitles - the current subtitles or null if none
 * }
 */
export function useSubtitles() {
    const wrapper = useVideoEl();
    const subtitlesEnabled = useStore((state) => state.subtitlesEnabled);
    const isMinimized = useVideoPlayerStore(videoPlayerIsMinimizedSelector);
    const video = useStore((state) => state.video);
    const currentSubtitlesId = useStore((state) => state.currentSubtitlesId);
    const subtitles = useMemo(() => {
        if (!video ||
            (video.video_subtitles.length === 0 &&
                (!video.live_stream_subtitles ||
                    video.live_stream_subtitles?.length === 0))) {
            return [];
        }
        return isLiveStream(video)
            ? formatLiveStreamSubtitles(video.live_stream_subtitles)
            : formatVideoSubtitles(video?.video_subtitles);
    }, [video]);
    const subtitleId = currentSubtitlesId || subtitles?.[0]?.id;
    const currentSubtitles = subtitles?.find((s) => s.id === subtitleId) ?? null;
    const subsAreEnabled = !!(video &&
        wrapper &&
        !isMinimized &&
        subtitlesEnabled);
    return {
        subsAreEnabled,
        currentSubtitles,
        subtitles,
    };
}
